import { render } from "./Sponsors.vue?vue&type=template&id=39cf9bb7"
import script from "./Sponsors.vue?vue&type=script&lang=js"
export * from "./Sponsors.vue?vue&type=script&lang=js"

import "./Sponsors.vue?vue&type=style&index=0&id=39cf9bb7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__